// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"5b949591","397":"3004be76","664":"c2103ec5","902":"ca77bcc9","931":"fe8be075"}[chunkId] + ".chunk.js";
};